"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgSubtract(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "7 -4 10 24" }, props),
        React.createElement("path", { d: "M7 8.714V7.286h10v1.428z", fill: "currentColor" })));
}
exports.default = tombacIcon_1.default('Subtract')(SvgSubtract);
//# sourceMappingURL=Subtract.js.map